import {
	AfterViewInit,
	Component,
	ElementRef,
	HostBinding,
	OnDestroy,
	ViewChild,
	inject,
	input,
} from '@angular/core'

import { wrapperDialogImports as imports } from './wrapper-dialog.imports'
import { WrapperDialogState } from './wrapper-dialog.state'

@Component({
	selector: 'wrapper-dialog',
	templateUrl: './wrapper-dialog.component.html',
	styleUrl: './wrapper-dialog.component.scss',
	standalone: true,
	imports,
})
export class WrapperDialogComponent implements AfterViewInit, OnDestroy {
	readonly #wrapperDialogState = inject(WrapperDialogState)

	@ViewChild('section') section: ElementRef<HTMLElement>

	readonly headlining = input<string>('')

	readonly paddingless = input<boolean>(false)
	readonly exitButton$ = this.#wrapperDialogState.exitButton$

	@HostBinding('class.paddingless') get paddinglessClass() {
		return this.paddingless()
	}

	ngAfterViewInit(): void {
		this.#wrapperDialogState.isScrollBottom$.subscribe(() => {
			this.#onBottomScrollNavigation()
		})

		this.#wrapperDialogState.isScrollable$.subscribe((isScrollable) => {
			this.#setOverflowHidden(isScrollable)
		})

		this.#wrapperDialogState.isScrollTop$.subscribe(() => {
			this.#onTopScrollNavigation()
		})
	}

	#onTopScrollNavigation(): void {
		this.section.nativeElement.scrollTo({
			top: 0,
			left: 0,
		})
	}

	#onBottomScrollNavigation(): void {
		this.section.nativeElement.scrollTo({
			top: this.section.nativeElement.scrollHeight,
			behavior: 'smooth',
			left: 0,
		})
	}

	#setOverflowHidden(isScrollable: boolean = false): void {
		const overflow = isScrollable ? 'hidden' : 'auto'

		this.section.nativeElement.style.overflow = overflow
	}

	ngOnDestroy(): void {
		this.#wrapperDialogState.enableExitButton()
	}
}
